const langs = {  af: 'Afrikaans',
am: 'Amharic',
ar: 'Arabic',
'oc-ES': 'Aranese',
auto: 'Detect Language',
eu: 'Basque',
bg: 'Bulgarian',
bn: 'Bangla',
bs: 'Bosnian',
ca: 'Catalan',
co: 'Corsican',
cs: 'Czech',
cy: 'Welsh',
da: 'Danish',
gl: 'Galician',
de: 'German',
el: 'Greek',
en: 'English',
'en-CA': 'English (Canada)',
'en-US': 'English (United States)',
'en-GB': 'English (United Kingdom)',
es: 'Spanish',
'es-LA': 'Spanish (Latin America)',
'es-MX': 'Spanish (Mexico)',
'es-XM': 'Spanish (International)',
'es-US': 'Spanish (United States)',
et: 'Estonian',
fa: 'Persian',
fi: 'Finnish',
tl: 'Filipino',
fj: 'Fijian',
fr: 'French',
'fr-BE': 'French (Belgium)',
'fr-CA': 'French (Canada)',
'fr-FR': 'French (France)',
he: 'Hebrew',
hi: 'Hindi',
hm: 'Hmong',
hr: 'Croatian',
ht: 'Haitian Creole',
hu: 'Hungarian',
hy: 'Armenian',
id: 'Indonesian',
is: 'Icelandic',
it: 'Italian',
ja: 'Japanese',
km: 'Khmer',
ko: 'Korean',
ka: 'Georgian',
'lb-LU': 'Luxembourgish',
lo: 'Lao',
lt: 'Lithuanian',
lv: 'Latvian',
mg: 'Malagasy',
mk: 'Macedonian',
mn: 'Mongolian',
ms: 'Malay',
mt: 'Maltese',
my: 'Burmese',
multi: 'Multilingual',
mww: 'Hmong Daw',
ne: 'Nepali',
no: 'Norwegian',
nl: 'Dutch',
'nl-BE': 'Dutch (Belgium)',
otq: 'Querétaro Otomi',
pl: 'Polish',
pt: 'Portuguese',
'pt-PT': 'Portuguese (Portugal)',
'pt-BR': 'Portuguese (Brasil)',
ro: 'Romanian',
rw: 'Kinyarwanda',
ru: 'Russian',
sk: 'Slovak',
sl: 'Slovenian',
si: 'Sinhala',
sm: 'Samoan',
sr: 'Serbian',
'sr-RS-CYRL': 'Serbian (Cyrillic)',
'sr-RS-LATN': 'Serbian (Latin)',
sv: 'Swedish',
sw: 'Kiswahili',
ta: 'Tamil',
th: 'Thai',
tlh: 'Klingon',
ti: 'Tigrinya',
to: 'Tongan',
tr: 'Turkish',
ty: 'Tahitian',
uk: 'Ukrainian',
ur: 'Urdu',
vi: 'Vietnamese',
yua: 'Yucatec Maya',
yue: 'Cantonese',
sq: 'Albanian',
az: 'Azerbaijani',
be: 'Belarusian',
eo: 'Esperanto',
gd: 'Gaelic (Scotland)',
ga: 'Gaelic (Ireland)',
kn: 'Kannada',
gu: 'Gujarati',
ha: 'Hausa',
la: 'Latin',
mr: 'Marathi',
tg: 'Tajik',
te: 'Telugu',
uz: 'Uzbek',
xh: 'Xhosa',
yi: 'Yiddish',
zu: 'Zulu',
cb: 'Cebuano',
fy: 'Frisian',
haw: 'Hawaiian',
ig: 'Igbo',
jv: 'Javanese',
kk: 'Kazakh',
ku: 'Kurdish',
ky: 'Kyrgyz',
ml: 'Malayalam',
mi: 'Maori',
ny: 'Nyanja',
or: 'Odia',
ps: 'Pashto',
pa: 'Punjabi',
st: 'Sesotho',
sn: 'Shona',
sd: 'Sindhi',
so: 'Somali',
su: 'Sundanese',
tt: 'Tatar',
tk: 'Turkmen',
ug: 'Uyghur',
yo: 'Yoruba',
'zh-CN': 'Chinese (Simplified)',
'zh-TW': 'Chinese (Traditional)',
'zh-HK': 'Chinese (Hong Kong)',
fl:"mystery",
"tlh-Qaak":"Klingon",
}
export default langs